import type { ReturnsFlowStateModel } from '@/services/models/Returns';
import type { Nullable } from '@/type-utils';
import { createContext } from 'react';

/**
 * The context for handling the {@link ReturnsFlowStateModel returns flow}
 * data inside of the application.
 */
export const ReturnsFlowContext =
  createContext<Nullable<ReturnsFlowStateModel>>(null);

ReturnsFlowContext.displayName = 'ReturnsFlowContext';
